import { useEffect } from 'react';
import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { CreationMenu } from 'components/CreationMenu';
import { SidePanelStack } from 'components/sidePanel/SidePanelStack';
import { React } from 'libs/react';
import { UpdateContactPanel } from '../panels/UpdateContactPanel';
import { useTranslation } from 'components/translation/TranslationProvider';
/**
 * @component ContactQuickEditMenu
 * @since 1.0.0
 */
export function ContactQuickEditMenu(props) {
    const { style, open, hideButton, isEndClient, contact } = Object.assign({ style: 'normal' }, props);
    const { customLabels, language } = useTranslation();
    const [title, setTitle] = useState('');
    const [picto, setPicto] = useState('');
    const [navigationStack, setNavigationStack] = useState([]);
    /**
     * @function onOpen
     * @since 1.0.0
     * @hidden
     */
    const onOpen = () => {
        pushPanel('edit-contact');
    };
    useEffect(() => {
        if (open) {
            onOpen();
        }
    }, [open]);
    /**
     * @function onBack
     * @since 1.0.0
     * @hidden
     */
    const onBack = () => {
        if (navigationStack.length == 0) {
            return;
        }
        navigationStack.pop();
        setNavigationStack(navigationStack.slice());
    };
    /**
     * @function pushPanel
     * @since 1.0.0
     * @hidden
     */
    const pushPanel = (destination) => {
        const panelIndex = PanelInfos.findIndex((info) => info.index == destination);
        const infos = PanelInfos.find((info) => info.index == destination);
        if (!infos || panelIndex < 0) {
            return;
        }
        navigationStack.push({
            index: panelIndex + 1,
            item: Object.assign(Object.assign({}, infos), { title: `${t('Edit')} ${isEndClient
                    ? customLabels['contact'][language]
                    : customLabels['representative'][language]}` })
        });
        setNavigationStack(navigationStack.slice());
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        var _a;
        setNavigationStack([]);
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    /**
     * @function onContactUpdateDone
     * @since 1.0.0
     * @hidden
     */
    const onContactUpdateDone = (contact) => {
        onClose();
        props.onContactUpdateDone && props.onContactUpdateDone(contact);
    };
    /**
     * @function onCancel
     * @since 1.0.0
     * @hidden
     */
    const onCancel = () => {
        onClose();
    };
    useEffect(() => {
        var _a, _b;
        const lastItem = navigationStack.length > 0
            ? navigationStack[navigationStack.length - 1]
            : null;
        setTitle((_a = lastItem === null || lastItem === void 0 ? void 0 : lastItem.item.title) !== null && _a !== void 0 ? _a : '');
        setPicto((_b = lastItem === null || lastItem === void 0 ? void 0 : lastItem.item.picto) !== null && _b !== void 0 ? _b : '');
    }, [navigationStack]);
    const className = classNames('quick-edit-panel-stack', 'quick-edit-panel-stack--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(CreationMenu, { active: navigationStack.length > 0, onOpen: onOpen, hideButton: hideButton },
            React.createElement(SidePanelStack, { active: navigationStack.length > 0, activeIndex: navigationStack.length > 0
                    ? navigationStack[navigationStack.length - 1].index
                    : 0, onBack: onBack, title: title, picto: picto, onClose: onClose },
                React.createElement(UpdateContactPanel, { contact: contact, onDone: onContactUpdateDone, onCancel: onCancel, isEndClient: isEndClient })))));
}
/**
 * @const PanelInfos
 * @since 1.0.0
 */
export const PanelInfos = [
    {
        index: 'edit-contact',
        title: t('Contact')
    }
];
